import React from "react";
import PropTypes from "prop-types";
import { Button } from "arv-reactcomponents";

const NextButton = props => {
  const { next, disabled, className } = props;
  if (next) {
    return (
      <div className={`nw-nextbtn-wrapper ${className}`}>
        <Button
          onClick={next}
          className="nw-nextbtn-button"
          disabled={disabled}
        >
          <i className="icomoon-arrow_right1 nw-nextbtn-ico" />
        </Button>
      </div>
    );
  }
  return null;
};

NextButton.defaultProps = {
  next: PropTypes.func,
  disabled: false,
  className: "",
};

NextButton.propTypes = {
  next: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: NextButton,
  component: NextButton,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/NextButton/index.js